import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { NavigationNodeId } from '@pwc/pwc-deals-web-common';
import { getNavigationTitle } from 'common/helpers/getCustomNavigationTitles';
import { AnalysesTableRow } from './AnalysesTableRow';
import { DisplayableContent } from './ConnectedKfaPropTypes';
import { sortAnalysesByDate } from '../../../common/helpers/analysesUtils';
import './AnalysesAndInsightsTable.scss';
import Separator from '../../../common/components/Separator';
import { useKFATitleI18n } from '../../../common/hooks/useKFATitleI18n';

export const AnalysesAndInsightsTable = ({
  hypothesis,
  hypothesisIndex,
  projectId,
  allRetrievedConnections,
  sortByDate = true,
}) => {
  const connectedAnalyses = useMemo(
    () =>
      hypothesis && hypothesis.connectedAnalyses
        ? [...hypothesis.connectedAnalyses]
        : [],
    [hypothesis]
  );

  let sortedAnalyses = connectedAnalyses;
  if (sortByDate) {
    sortedAnalyses = sortAnalysesByDate(
      connectedAnalyses,
      allRetrievedConnections
    );
  }

  const KFATitle = getNavigationTitle(NavigationNodeId.KEY_FOCUS_AREAS);
  const KFATitleI18n = useKFATitleI18n(KFATitle);
  const { t } = useTranslation();

  return (
    <div
      className="connected-analyses"
      data-testid="analyses-and-insights-details"
    >
      <Separator />
      {sortedAnalyses.length ? (
        <>
          <span
            data-testid="analyses-header"
            className={classnames('connected-analyses__header')}
          >
            {t('analyses')}
          </span>
          <AnalysesTableRow
            projectId={projectId}
            analyses={sortedAnalyses}
            hypothesisIndex={hypothesisIndex}
          />
        </>
      ) : (
        <div className="no-content-msg">
          {t('noAnalysesConnectedKfa', { KFATitle: KFATitleI18n })}
        </div>
      )}
    </div>
  );
};

AnalysesAndInsightsTable.propTypes = {
  hypothesisIndex: PropTypes.number.isRequired,
  projectId: PropTypes.string.isRequired,
  hypothesis: PropTypes.shape({
    ...DisplayableContent,
    connectedAnalyses: PropTypes.arrayOf(PropTypes.shape(DisplayableContent)),
  }).isRequired,
};
